import { ToastrService } from 'ngx-toastr';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { catchError, of } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

import { PromotionType } from '@sifca-monorepo/ecommerce-generator';
import { AppService, AuthService, SharedService, SlidesService, UtilsService } from '../../services';

import { BarcodeType, DiscountType, SlidesType } from '@sifca-monorepo/ecommerce-generator';
import { OrdersService } from '../../services/order/order/order.service';

@Component({
  template: '',
})
export class BaseIndexDealComponent implements OnInit, AfterViewInit {
  days: any;
  hours: any;
  minutes: any;
  seconds: any;
  targetDate: any;
  targetTime: any;
  difference: number;
  deal: PromotionType[];
  now: any = Date.now();
  date: any = new Date();
  isButtonDisabled: boolean;
  priceAfterReduction: number;
  months: Array<string> = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  isOutOfStock: boolean;
  authenticated: boolean;
  posId: string = '';
  protected slides: SlidesType[] = [];

  constructor(
    protected appService: AppService,
    protected authService: AuthService,
    protected formBuilder: FormBuilder,
    protected utilsService: UtilsService,
    protected orderService: OrdersService,
    protected toastrService: ToastrService,
    protected slidesService: SlidesService,
    protected sharedService: SharedService,
    protected changeDetectorRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
    this.authService.authenticated$.subscribe((authenticated: boolean) => {
      this.authenticated = authenticated;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnInit(): void {
    this.appService
      .getSimpleOngoingPromotionsByTargetPaginate(this.posId)
      .pipe(
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe((res) => {
        this.deal = res;
        const datepipe: DatePipe = new DatePipe('en-US');
        const formatedDate = datepipe.transform(this.deal[0]?.endDate, 'dd,MMM,YYYY');
        this.targetDate = new Date(formatedDate);
        this.targetTime = this.targetDate.getTime();
        if (this.deal[0]?.promotion[0]?.discount.discountType === DiscountType.AMOUNT) {
          this.priceAfterReduction = Number(this.deal[0].promotion[0].barcode?.price) - Number(this.deal[0].promotion[0]?.discount.amount);
        }
        if (this.deal[0]?.promotion[0]?.discount.discountType === DiscountType.PERCENTAGE) {
          const discountPercentage = Number(this.deal[0].promotion[0]?.discount.amount);
          const discount = (Number(this.deal[0].promotion[0].barcode?.price) * discountPercentage) / 100
          this.priceAfterReduction = Number(this.deal[0].promotion[0].barcode?.price) - discount;
        }
        this.changeDetectorRef.markForCheck();
      });
      this.slidesService.slides$.subscribe((slides: SlidesType[]) => {
        if (slides) {
          this.slides = slides;
          this.handleSlides();
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      setInterval(() => {
        this.difference = this.targetTime - this.now;
        this.tickTock();
        this.difference = this.difference / (1000 * 60 * 60 * 24);
        this.days = isNaN(this.days) ? 0 : Math.floor(this.difference);
      }, 1000);
      this.changeDetectorRef.markForCheck();
    }
  }

  addToCart(barcode: BarcodeType) {
    this.isButtonDisabled = true;
    this.appService
      .getStockByTargetAndBarcode(barcode?.id)
      .pipe(
        catchError(() => {
          this.isOutOfStock = true;
          this.toastrService.error('Le produit est en rupture de stock !');
          return of(null);
        }),
      )
      .subscribe((res) => {
        if (res) {
          this.isOutOfStock = res.outOfStock;
          if (this.isOutOfStock === true) {
            this.toastrService.error('Le produit est en rupture de stock !');
          } else {
            if (!this.authenticated) {
              if (this.appService.itemInCart(barcode)) {
                const value: any = {
                  barcode: barcode,
                  price: {
                    unitGross: barcode?.price,
                    gross: barcode?.price,
                  },
                  product: barcode?.product,
                  quantity: 1,
                };
                this.appService.updateLocalCart(value);
              } else {
                const value: any = {
                  barcode,
                  price: {
                    unitGross: barcode?.price,
                    gross: barcode?.price,
                  },
                  product: barcode?.product,
                  quantity: 1,
                };
                this.appService.addToLocalCart(value);
              }
              this.toastrService.success('Produit ajouté au panier.');
              this.isButtonDisabled = false;
            } else {
              const formValue = {
                barcode: barcode?.id,
                quantity: 1,
              };
              this.orderService
                .addProductsToCart([formValue])
                .pipe(
                  catchError(() => {
                    this.toastrService.error("Quelque chose s'est mal passé");
                    return of(null);
                  }),
                )
                .subscribe((res) => {
                  if (res) {
                    this.toastrService.success('Produit ajouté au panier.');
                  }
                });
              this.appService.loadCart();
            }
          }
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  tickTock() {
    this.date = new Date();
    this.now = this.date.getTime();
    this.days = Math.floor(this.difference);
    this.hours = 23 - this.date.getHours();
    this.minutes = 60 - this.date.getMinutes();
    this.seconds = 60 - this.date.getSeconds();
    this.changeDetectorRef.markForCheck();
  }

  protected handleSlides(): void {
    // Implement slide handling logic in the derived components.
  }
}
